import { AxiosRequestConfig } from 'axios'
import { AdoptionAttemptDto } from '../gen/backendClient'
import { backendClient } from './client'

// These types are written by hand on purpose: the generated client is not regenerated for the guest adoption
// endpoints (see petso/petso-backend#430).

export interface GuestAdopterIdentityDto {
  firstName: string
  lastName: string
  email: string
  civility?: string
  phoneNumber?: string
  address?: string
  postalCode?: string
  city?: string
  country?: string
}

export interface CreateGuestAdoptionBodyDto {
  animalId: string
  priceInEuros?: number
  adopterId?: string
  adopter?: GuestAdopterIdentityDto
  sendEmailToAdopter?: boolean
  /** Deposit already recorded for this adoption, in euros. */
  depositAmount?: number
  /** Whether that deposit has been collected. Only a collected one reduces what is left to pay. */
  depositPaid?: boolean
  depositDate?: string
}

export interface RefreshGuestAdoptionLinkBodyDto {
  priceInEuros?: number
  sendEmailToAdopter?: boolean
}

export interface GuestAdoptionLinkDto {
  adopterId: string
  attemptId: string
  /** Secret: it grants access to the payment. Never log it nor send it to any analytics or monitoring tool. */
  token: string
  checkoutUrl: string
  expiresAt: string
  amountInCents: number
  emailSent: boolean
  /** The attempt that was created, as the classical creation endpoints return it. */
  attempt: AdoptionAttemptDto
}

export interface AdoptionAttemptGuestCheckoutDto {
  /** Secret: it grants access to the payment. Never log it nor send it to any analytics or monitoring tool. */
  token: string
  amountInCents: number
  donationInCents?: number
  createdAt: string
  expiresAt: string
  createdByAccountId?: string
  paidAt?: string
  paymentIntentId?: string
  profileInviteSentAt?: string
  profileClaimedAt?: string
}

export type AdoptionAttemptWithGuestCheckoutDto = AdoptionAttemptDto & {
  guestCheckout?: AdoptionAttemptGuestCheckoutDto
}

export class GuestAdoptionsClient {
  public static async createGuestAdoption(params: CreateGuestAdoptionBodyDto): Promise<GuestAdoptionLinkDto> {
    const config: AxiosRequestConfig<CreateGuestAdoptionBodyDto> = {
      method: 'POST',
      url: '/guest-adoptions',
      data: params,
    }

    const response = await backendClient<GuestAdoptionLinkDto>(config)

    return response.data
  }

  public static async refreshGuestAdoptionLink(
    adopterId: string,
    attemptId: string,
    params: RefreshGuestAdoptionLinkBodyDto = {}
  ): Promise<GuestAdoptionLinkDto> {
    const config: AxiosRequestConfig<RefreshGuestAdoptionLinkBodyDto> = {
      method: 'POST',
      url: `/guest-adoptions/${adopterId}/${attemptId}/refresh-link`,
      data: params,
    }

    const response = await backendClient<GuestAdoptionLinkDto>(config)

    return response.data
  }
}
